import { useReactFlow } from 'reactflow';
import { useAppDispatch, useAppSelector } from '@hooks/store';
import {
  resetCanvasZoom,
  selectCanvasZoom,
  setCanvasZoom,
} from '@store/slices/uiSlice';

export const useCanvasZoomActions = () => {
  const dispatch = useAppDispatch();
  const { getZoom } = useReactFlow();

  const setZoom = (zoom: number) => {
    dispatch(setCanvasZoom(zoom));
  };

  const resetZoom = () => {
    dispatch(resetCanvasZoom());
  };

  const saveCurrentZoom = () => {
    setZoom(getZoom());
  };

  return { setZoom, resetZoom, saveCurrentZoom };
};

const useCanvasZoom = () => {
  const zoom = useAppSelector(selectCanvasZoom);
  const actions = useCanvasZoomActions();

  return { zoom, ...actions };
};

export default useCanvasZoom;
